/* eslint-disable react/no-danger */
import { CircularProgress, Divider } from '@mui/material'
import { GET_REACH_CONTENT, GET_TAGS_BOX, postContentReach } from 'api'
import { getTagsInfo } from 'api/get/reach/reach'
import clsx from 'clsx'
import { Button } from 'components/buttons'
import { Modal } from 'components/modal'
import { TagAudience } from 'components/reachModal/tagAudience'
import { useSearchDebounce } from 'hooks'
import { Icons, Reach } from 'interfaces'
import dayjs from 'lib/dayjs'
import React, { useState } from 'react'
import { useInfiniteQuery, useQuery } from 'react-query'
import Cookies from 'universal-cookie'
import { formatLocalTime } from 'utils'
import { ListTags } from './listTags'
import { TitleBox } from './titleBox'
import { TitleContent } from './titleContent'
import { TitleContentRecurrence } from './titleContentRecurrence'
import { ConfirmationPushProps } from './types'

export const ConfirmationPush: React.FC<ConfirmationPushProps> = ({
	totalData,
	changeModal,
	handleSubmit,
	contentType
}) => {
	const cookies = new Cookies()
	const organizationId = cookies.get('organization_id')

	const { delivery_enhancements: delivery } = totalData
	const { audience, detailed_reach: detailedReach } = delivery
	const hasAudience = Object.values(audience).some(
		array => Array.isArray(array) && array.length > 0
	)
	const hasTags = (detailedReach?.tag.total ?? 0) > 0
	const hasStaticLists = (detailedReach?.static_list.total ?? 0) > 0
	const hasDynamicLists = (detailedReach?.dynamic_list.total ?? 0) > 0
	const hasIndividuals = (detailedReach?.individual.total ?? 0) > 0

	const dataRequestReach: Reach = {
		tags: [],
		lists: [],
		dynamic_lists: [],
		individuals: [],
		organizations: [],
		feeds: [],
		partner_lists: [],
		organization_id: organizationId
	}

	const {
		inputSearch: inputSearchTags,
		handleChangeDebounce: handleChangeDebounceTags,
		resetInput: resetInputTags
	} = useSearchDebounce('')
	const numberElement = 10
	const [isOpenTagBoxModal, setIsOpenTagBoxModal] = useState(false)
	const [page, setPage] = useState<number>(1)
	const [valueItemsTags, setValueItemsTags] = useState(numberElement)
	const [searchTags, setSearchTags] = useState('')

	const { data, isLoading } = useQuery(
		[GET_REACH_CONTENT, hasAudience],
		() => postContentReach(dataRequestReach),
		{ enabled: !hasAudience }
	)

	const reach = data?.reach.toString() ?? detailedReach?.total.toString()

	const objectSchedule = totalData.delivery_enhancements.schedule
	const hasSchedule =
		objectSchedule.timing.release_date ||
		objectSchedule.custom_recurrence.repeat_start_date

	const {
		data: dataTagBox,
		isLoading: isLoadingTagBox,
		hasNextPage: hasNextPageTagsReach,
		fetchNextPage: fetchNextPageTagsReach,
		isFetchingNextPage: isFetchingNextPageTagsReach
	} = useInfiniteQuery({
		queryKey: [
			GET_TAGS_BOX,
			audience.tags,
			organizationId,
			page,
			valueItemsTags,
			inputSearchTags
		],
		queryFn: () =>
			getTagsInfo(
				audience.tags,
				organizationId,
				page,
				valueItemsTags,
				inputSearchTags
			),
		getNextPageParam: response => {
			const nextPage = Number(response?.page) + 1
			if (nextPage <= Number(response?.pages)) {
				return nextPage
			}
			return undefined
		}
	})

	return (
		<div>
			<div className="overflow-y-scroll  hide-scroll-bar max-h-[80vh] mt-3">
				<div className="border border-blue-primary rounded-lg p-4 my-4">
					<TitleBox icon={Icons.preview} title="Review:" />
					<div className="flex items-stretch gap-4">
						<div className="border border-blue-primary rounded-lg p-4 flex-grow flex flex-col h-full min-h-[197px] min-w-[200px]">
							<div className="flex-grow">
								<p className="text-[15px] text-black-1 font-bold font-Inter">
									{totalData.set_up.title}
								</p>
								<hr className="my-2" />
								<div
									className="text-[15px] text-black-1 font-normal font-Inter"
									dangerouslySetInnerHTML={{
										__html: totalData.set_up.message || ''
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="border border-blue-primary rounded-lg p-4 my-4">
					<TitleBox icon={Icons.displaySettings} title="Push Notification:" />
					<div className="flex flex-col items-start justify-center gap-4">
						<TitleContent
							title="Link to:"
							content={totalData.set_up.cta_Type?.toUpperCase() || 'None'}
							content2={
								totalData.set_up.cta_Type !== 'content'
									? totalData.set_up.link_to
										? totalData.set_up.link_to
										: undefined
									: contentType.name
							}
						/>
						{hasSchedule && (
							<TitleContentRecurrence
								type="push"
								endTitle={
									objectSchedule.custom_recurrence.ends.repeat_end_type ===
									'after_ocurrence'
										? 'after'
										: 'on'
								}
								publish={formatLocalTime(
									objectSchedule.timing.release_date as string,
									'MM/DD/YYYY hh:mm A'
								)}
								recurrent={objectSchedule.timing.release_date === ''}
								endsRecurrent={
									objectSchedule.custom_recurrence.ends.repeat_end_type ===
									'never'
										? 'Never'
										: objectSchedule.custom_recurrence.ends.repeat_end_type ===
										  'after_ocurrence'
										? `${objectSchedule.custom_recurrence.ends.repeat_end_value} Occurrences`
										: dayjs(
												objectSchedule.custom_recurrence.ends.repeat_end_date
										  ).format('MM/DD/YYYY')
								}
								publishRecurrent={dayjs(
									objectSchedule.custom_recurrence.repeat_start_date
								).format('MM/DD/YYYY')}
								repeatEveryRecurrent={`${objectSchedule.custom_recurrence.repeat_every_value} ${objectSchedule.custom_recurrence.repeat_every_type}`}
								repeatOnRecurrent={dayjs(
									objectSchedule.custom_recurrence.repeat_on
								).format('MM/DD/YYYY')}
								listDaysRecurrence={
									objectSchedule.custom_recurrence.repeat_every_type === 'week'
										? objectSchedule.custom_recurrence.repeat_on
												// eslint-disable-next-line no-useless-escape
												.replace(/[\[\]']+/g, '')
												.split(',')
										: undefined
								}
							/>
						)}
					</div>
				</div>

				<div className="border border-blue-primary rounded-lg p-4 my-4">
					<TitleBox icon={Icons.audience} title="Audience:" />
					{isLoading ? (
						<div className="flex h-full w-full justify-center items-center">
							<CircularProgress disableShrink />
						</div>
					) : (
						<>
							<div className="overflow-y-auto max-h-[300px]">
								{hasAudience && (
									<>
										{hasTags && (
											<>
												<TitleContent
													title="Tags:"
													content={detailedReach?.tag.total.toString() || '0'}
													noBorder
													isFull
													isBig
													onClickContent={() => {
														setIsOpenTagBoxModal(true)
													}}
												/>
												<ListTags listTags={detailedReach?.tag.list || []} />
												<Divider />
											</>
										)}
										{hasStaticLists && (
											<>
												<TitleContent
													title="Static Lists:"
													content={
														detailedReach?.static_list.total.toString() || '0'
													}
													noBorder
													isFull
													isBig
												/>
												<ListTags
													listTags={detailedReach?.static_list.list || []}
												/>
												<Divider />
											</>
										)}
										{hasDynamicLists && (
											<>
												<TitleContent
													title="Dynamic Lists:"
													content={
														detailedReach?.dynamic_list.total.toString() || '0'
													}
													noBorder
													isFull
													isBig
												/>
												<ListTags
													listTags={detailedReach?.dynamic_list.list || []}
												/>
												<Divider />
											</>
										)}
										{hasIndividuals && (
											<>
												<TitleContent
													title="Individuals:"
													content={
														detailedReach?.individual.total.toString() || '0'
													}
													noBorder
													isFull
													isBig
												/>
												<ListTags
													listTags={detailedReach?.individual.list || []}
												/>
											</>
										)}
									</>
								)}

								{!hasAudience && !isLoading && (
									<TitleContent
										title=" All of My People:"
										content={reach ?? '0'}
										noBorder
										isFull
										isBig
									/>
								)}
							</div>
							<div className="mt-4 pt-2 border-t-2 border-blue-primary flex items-center gap-2 justify-between">
								<TitleBox title="Total:" />
								<p
									className={clsx(
										`text-[22px] text-white font-normal font-Inter border border-blue-primary bg-blue-primary rounded-full px-2 ${
											reach && reach.toString().length === 1
												? 'w-[44px] h-[44px] flex items-center justify-center'
												: 'max-w-max'
										} capitalize mb-4`
									)}
								>
									{reach || 0}
								</p>
							</div>
						</>
					)}
				</div>
				<Modal
					setOpen={setIsOpenTagBoxModal}
					open={isOpenTagBoxModal}
					type="normal"
					sizeModal="h-[418px] p-2"
					maxWidth="max-w-[302px]"
					marginL
				>
					<TagAudience
						resetInput={resetInputTags}
						handleChangeDebounce={handleChangeDebounceTags}
						setSearchTags={setSearchTags}
						searchTags={searchTags}
						dataTagsAudience={dataTagBox}
						isLoadingTagsAudience={isLoadingTagBox}
						page={page}
						setPage={setPage}
						valueItems={valueItemsTags}
						setValueItems={setValueItemsTags}
						fetchNextPageTagsReach={fetchNextPageTagsReach}
						hasNextPageTagsReach={hasNextPageTagsReach}
						isFetchingNextPageTagsReach={isFetchingNextPageTagsReach}
					/>
				</Modal>
			</div>
			<div className="flex items-center justify-end mt-4 gap-6">
				<Button
					type="button"
					label="Back to editing"
					color="Gray3"
					className="!min-w-[130px]"
					iconRight={Icons.edit}
					onClick={() => changeModal(false)}
				/>
				<Button
					type="button"
					label="Publish now"
					color="Primary"
					iconRight={Icons.playArrow}
					className="!min-w-[130px]"
					onClick={() => handleSubmit('processing')}
				/>
			</div>
		</div>
	)
}
